'use client';

import { Box, Button, Stack, Typography } from '@mui/material';
import Link from 'next/link';
import { faqConsultantPhone, faqConsultantPhoneLabel, faqHelpLinks } from '@/containers/faq/constants/faqContent';
import AnimationFadeUp from '@/components/animations/AnimationFadeUp';
export default function FaqHelpSection() {
  return <AnimationFadeUp delay={0.15} data-sentry-element="AnimationFadeUp" data-sentry-component="FaqHelpSection" data-sentry-source-file="FaqHelpSection.tsx">
      <Box sx={{
      mt: {
        xs: 'var(--spacing_l)',
        md: 'var(--spacing_xl)'
      },
      p: {
        xs: 'var(--spacing_m)',
        md: 'var(--spacing_l)'
      },
      borderRadius: 'var(--corner_radius_xl)',
      bgcolor: 'primaryBrand.bg6',
      border: '1px solid',
      borderColor: 'primaryBrand.bg4'
    }} data-sentry-element="Box" data-sentry-source-file="FaqHelpSection.tsx">
        <Stack direction={{
        xs: 'column',
        md: 'row'
      }} alignItems={{
        xs: 'stretch',
        md: 'center'
      }} justifyContent='space-between' spacing='var(--spacing_m)' data-sentry-element="Stack" data-sentry-source-file="FaqHelpSection.tsx">
          <Stack spacing='var(--spacing_xxs)' sx={{
          maxWidth: 480
        }} data-sentry-element="Stack" data-sentry-source-file="FaqHelpSection.tsx">
            <Typography sx={{
            typography: 'bodyLargeStrong__Wallfund',
            color: 'text.text'
          }} data-sentry-element="Typography" data-sentry-source-file="FaqHelpSection.tsx">
              پاسخ خود را پیدا نکردید؟
            </Typography>
            <Typography sx={{
            typography: 'bodyRegular__Wallfund',
            color: 'text.text2'
          }} data-sentry-element="Typography" data-sentry-source-file="FaqHelpSection.tsx">
              با شماره‌ای که روی دکمه نوشته شده، تماس با مشاوره بگیرید.
            </Typography>
          </Stack>

          <Stack direction={{
          xs: 'column',
          sm: 'row'
        }} spacing='var(--spacing_s)' sx={{
          flexShrink: 0
        }} data-sentry-element="Stack" data-sentry-source-file="FaqHelpSection.tsx">
            <Button component='a' href={`tel:${faqConsultantPhone}`} variant='contained' color='tertiary' size='large' sx={{
            borderRadius: 'var(--corner_radius_l)',
            width: {
              xs: '100%',
              sm: 'auto'
            },
            whiteSpace: 'nowrap',
            direction: 'ltr'
          }} data-sentry-element="Button" data-sentry-source-file="FaqHelpSection.tsx">
              تماس با مشاوره {faqConsultantPhoneLabel}
            </Button>
            {faqHelpLinks.map(link => <Button key={link.href} component={Link} href={link.href} variant='outlined' color='primary' size='large' sx={{
            borderRadius: 'var(--corner_radius_l)',
            width: {
              xs: '100%',
              sm: 'auto'
            },
            whiteSpace: 'nowrap'
          }}>
                {link.label}
              </Button>)}
          </Stack>
        </Stack>
      </Box>
    </AnimationFadeUp>;
}